import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconComponentProps } from '../IconTypes';
import { IconWrapper } from '../IconWrapper';

import { faCheck } from '@fortawesome/pro-light-svg-icons';

export type ProLightCheckProps = IconComponentProps;

export const ProLightCheck = ({
  className,
  onClick,
  iconProps,
  type = 'button',
  ...props
}: ProLightCheckProps) => {
  if (onClick) {
    return (
      <IconWrapper
        {...props}
        className={['font-awesome-button', className].join(' ')}
        type={type}
        onClick={onClick}
      >
        <FontAwesomeIcon
          {...iconProps}
          className="font-awesome-icon"
          icon={faCheck}
        />
      </IconWrapper>
    );
  }
  return (
    <FontAwesomeIcon
      {...iconProps}
      className={['font-awesome-icon', className].join(' ')}
      icon={faCheck}
    />
  );
};

ProLightCheck.displayName = 'ProLightCheck';
